import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20intimate%20couple%20embracing%20softly%20in%20a%20sunlit%20room%20with%20sheer%20curtains%2C%20gentle%20golden%20light%2C%20cream%20and%20warm%20beige%20tones%2C%20romantic%20atmosphere%2C%20soft%20bokeh%20effect%2C%20fine%20art%20photography%2C%20emotional%20connection%2C%20elegant%20and%20tasteful%20composition&width=1800&height=1000&seq=hero-bg-01&orientation=landscape"
        alt="爱爱网 - 成人情感交流平台"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-3xl text-center px-4">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
            探索健康、开放的
            <br />
            亲密关系世界
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            爱爱网专注成人情感与亲密关系，提供专业情感咨询、两性健康知识和伴侣沟通技巧，陪伴您在爱的旅程中不断成长。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/emotional-consultation"
              className="px-8 py-3.5 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
            >
              开始探索
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-lg bg-white/15 text-white text-sm font-medium hover:bg-white/25 backdrop-blur-sm transition-all duration-300 cursor-pointer whitespace-nowrap border border-white/20"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}